export class ServiceHelpers {
  static getErrorMessage(errorResponse, altMessage): string {
    if (errorResponse.status === 0) {
      return 'Connection failed.';
    }

    // try to make a nicely formatted error message from the response
    let errors;
    if (errorResponse.error && errorResponse.error.errors) {
      errors = errorResponse.error.errors;
    } else if (errorResponse.errors) {
      errors = errorResponse.errors;
    } else if (errorResponse.error) {
      errors = errorResponse.error;
    }

    if (Array.isArray(errors)) {
      let message = '';
      errors.forEach(err => (message += err + '\n'));
      return message;
    } else if (typeof errors === 'object') {
      let message = '';
      for (const prop of Object.keys(errors)) {
        message += errors[prop] + '\n';
      }

      return message;
    } else if (altMessage) {
      return altMessage;
    } else {
      return 'Failed!';
    }
  }
}
